var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex flex-column h-100" }, [
    _c(
      "div",
      {
        staticClass:
          "modal-top bg-grey3 flex-between-center radius-18 radius-bottom-0 p-20 top-0 pos-sticky zindex-2",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "modal-top--title fsize-18 color-grey1 text-bold text-uppercase radius-18 radius-bottom-0",
          },
          [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(_vm.UpsellService.getSuggestionsProduct().dd) +
                "\n\t\t\t"
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "close rounded-btn display-1 p-10 bg-grey3",
            attrs: { type: "button", "aria-label": "Close" },
            on: {
              click: function ($event) {
                return _vm.modal.dismiss()
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "font-lato text-light",
                attrs: { "aria-hidden": "true" },
              },
              [_vm._v("×")]
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal-main bg-grey3 p-20 pos-relative zindex-0" },
      _vm._l(_vm.UpsellService.getSuggestions(), function (suggestion, i) {
        return _c(
          "div",
          { key: i, staticClass: "menuCateg" },
          [
            _c("menu-compo-list", {
              attrs: {
                cart: _vm.order.oi,
                "menu-compo": suggestion,
                category: {
                  joinPrices: null,
                  menuId: null,
                  ChoicesNumber: 1000,
                },
              },
              on: { "compo-taken": _vm.suggestionTaken },
            }),
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "modal-bottom bg-white w-100 flex-center-center pos-sticky bottom-0 zindex-1 radius-18 px-10 py-10 shadow-4",
      },
      [
        _c(
          "button",
          {
            staticClass: "btnFlat-color2 my-10 mx-10 flex-1 fsize-18 shadow-1",
            on: {
              click: function ($event) {
                return _vm.$emit("go")
              },
            },
          },
          [
            _c("span", [_vm._v("Continuer")]),
            _vm._v(" "),
            _c("i", { staticClass: "fie-icon_arrow2-r" }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }